import React from 'react';
import icons from "Common/Icons";
import ListComponent from 'Components/ListComponent';
import { PlusCircleFilled } from "@ant-design/icons";
import utils from 'utils';
import MyAvailabilityPopup from './MyAvailabilityPopup';
import dayjs from 'dayjs';
import { CONSTANTS } from 'utils/constant';

export default class extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data || [],
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.data != prevState.data) {
            return {
                data: nextProps.data || [],
                isEdit: nextProps.data && nextProps.data.length && true || false,
            }
        } else return null;
    }

    handlePopup(col) {
        let from = "start_time", to = "end_time", data = [...this.state.data];
        if (this.props.name == "doctor_holiday") {
            from = "start_day";
            to = "end_day";
        }
        data.forEach(obj => {
            let fromTime = utils.FormatDate(obj[from], "TIME_3"), toTime = utils.FormatDate(obj[to], "TIME_3");
            obj[from] = this.props.name == "doctor_holiday" ? dayjs(obj[from]) : `${utils.FormatDate(utils.TimezoneOffsetConversion(), "DATE_12")} ${fromTime}`;
            obj[to] = this.props.name == "doctor_holiday" ? dayjs(obj[to]) : `${utils.FormatDate(utils.TimezoneOffsetConversion(), "DATE_12")} ${toTime}`;
        })
        utils.Modal(true, { content: <MyAvailabilityPopup
             name={this.props.name} 
             from={from} 
             to={to} 
             data={{[this.props.name]: data}}
             handleFunction={ (col, value) => typeof this.props.handleFunction == "function" && this.props.handleFunction(col,value)} />, width: "500px" });
    }
    render() {
        return (<div className='my-availability-child'>
            <div className='main-content'>
                <div className='header-content'>
                    <div className='header-label'>
                        {this.props.title && this.props.title || "Available days and time slots"}
                    </div>
                    {this.state.isEdit ?
                        <div className='myavailability-edit' onClick={this.handlePopup.bind(this, "edit")}>
                            <img src={icons.edit_icon} />
                            <div>{CONSTANTS.EDIT}</div>
                        </div> : null
                    }
                </div>
                <div className='body-content'>
                    {this.state.isEdit ?
                        <ListComponent
                            data={this.state.data}
                            pagination={null}
                            render={obj => {
                                return <div className='available-list'>
                                    {obj.day? <div>{obj.day}</div> : null}
                                    <div>{obj.left_value}</div>
                                    <div>{obj.right_value}</div>
                                </div>
                            }} />
                        : <div className='add-content' onClick={this.handlePopup.bind(this, "add")}>
                            <PlusCircleFilled className='add-icon' />
                            <div>{CONSTANTS.CLICK_TO_PROCEED}</div>
                        </div>
                    }

                </div>
            </div>
        </div>);
    }
}



